module.exports = __webpack_public_path__ + "assets/img/mijuan.e6ad0e0a.png";